module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Regional-Landing-Page-w540.e00255ab.jpg";